import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "aside-logo flex-column-auto",
  id: "kt_aside_logo"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "kt_aside_toggle",
    class: "btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle",
    "data-kt-toggle": "true",
    "data-kt-toggle-state": "active",
    "data-kt-toggle-target": "body",
    "data-kt-toggle-name": "aside-minimize"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 rotate-180" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "las la-angle-double-left fs-2x" })
    ])
  ])
], -1)
const _hoisted_2 = { class: "aside-menu flex-column-fluid" }
const _hoisted_3 = {
  class: "aside-footer flex-column-auto pt-5 pb-7 px-5",
  id: "kt_aside_footer"
}
const _hoisted_4 = {
  class: "btn-label",
  style: {"color":"#444","max-width":"max(0px, calc((100% - 120px) * 999))","overflow":"hidden"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"#666","font-size":"10px","position":"absolute","bottom":"9px","max-width":"max(0px, calc((50% - 120px) * 999))","overflow":"hidden"} }, [
  /*#__PURE__*/_createTextVNode(" Con "),
  /*#__PURE__*/_createElementVNode("img", {
    height: "8",
    src: "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjIuODggMTA3LjM5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2VkMWIyNDtmaWxsLXJ1bGU6ZXZlbm9kZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnJlZC1oZWFydDwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNjAuODMsMTcuMThjOC04LjM1LDEzLjYyLTE1LjU3LDI2LTE3QzExMC0yLjQ2LDEzMS4yNywyMS4yNiwxMTkuNTcsNDQuNjFjLTMuMzMsNi42NS0xMC4xMSwxNC41Ni0xNy42MSwyMi4zMi04LjIzLDguNTItMTcuMzQsMTYuODctMjMuNzIsMjMuMmwtMTcuNCwxNy4yNkw0Ni40Niw5My41NUMyOS4xNiw3Ni44OSwxLDU1LjkyLDAsMjkuOTQtLjYzLDExLjc0LDEzLjczLjA4LDMwLjI1LjI5YzE0Ljc2LjIsMjEsNy41NCwzMC41OCwxNi44OVoiLz48L3N2Zz4=",
    style: {"vertical-align":"baseline","margin-left":"2px"}
  }),
  /*#__PURE__*/_createTextVNode(" desde Aragón por "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.maubic.es/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      height: "14",
      src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAAZCAMAAADqvJv3AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAADxQTFRFAAAA////BQUF8fHx+fn5VlZWDQ0NGhoac3Nzl5eXzMzM2dnZwMDAfHx8s7OzhoaGZmZmp6enQ0NDKysrZPtmrQAAA4ZJREFUeJytlodu5CAQQDFlKKbz//96U7B3c+uNdNKNFAdjmDc9UZCOT0laqWmsjWrLaW2WVbHWAK+MNbKVre1K4xFrjDkb3lXT2pN+K58N6rNpqicOkpRy9ji2SjVx6+SVpnuBl/hdvqKKIh9YrMfLeJdA4daoHjnHoRm0VbI1543cy09QCSEasVJAHQ+b2Es68jcQCEhUwkv7wAXb/ADibY2qLxAgtXIEAX4F4bkpmuwG4VWD4YjfQbh9g8IOIMubcrPGT1CyR5Zw5Q2KaCJYWT+DykF3BJS3SX+D8PT5A5TRFeBw+Q1CH7vCQ/4xRylTjdEVAfHpT5DxWk/7A9TpJIVLCQi4ptCt9kvVUVZukHsANdXaXY8SOmSculMABISI03vcoCZ59Aij/aq6H6DU+7kdAmM83TK4IyCKmjsJKyBuPnZ6fssRsHYBnXd/kPSuuWmH4nLCbDQN5wYtqmbKKIPmy/3IVCkpQ/ruqhukSkCDC2MLXgaugUVPdGkcUCZoAZFRrIBBVHsOJVz29qvL3AtUXyDUbecFwuNVecyF2JuUTirREBMQ5SwrAWm7Q0EmOUqYmVr7k0fVBlFG79BpzgNovWLgYvCqoYa8axww+uUCwU4ogagIZPhFonOdGSOX+A1nqpEZskeQ56QaHksHm+wTeKlsNIs8vkKnXOh6gzjpLJ6D7HfXGRrYd3nbCq+h6vNV81LeXXF3sJx8HxT0cMcXQxic6qVcA6WXjuq0izXHDnuLJHROFJSyW3W1WmuZu48wZetq1cNKH92i1T8JHQf43L+8v4fP1bCXrHuKuIfrn1sFXYrbyfevx7PAtg1zVS5Lsea1vvflJ26P9b0VF5okS5B9+fYVBHmEmUd0xQXVQ6sxrjhqKWlUqGNAGg7robWRg8sDtzOMWkNcK4+hU01xeHx3NYc64neQz06NpUYp6FMPmWzFR21djVZDConSXtUZWq5euYijEv3LeAr/QBRs2jgKDV/fESfj61OoYzUaslRsL9C8QDHOBTpGAqU5PVa0w5kcNwifyERQw9FU26yq5/f59SaOKjTkXkN1taeQV20YlBpaxLodLvfiYxg4UB1q62GEgCBXkdViwFs6xRzHrKFncigkMryJcB/wKsh/Sk4rP7VaXjuMEvmg3KLcggaswEUph6mmnMOs4qyhStB+8vWGGw7wKEB/KNj/JHPU9f7+BwpFJfVfRNytAAAAAElFTkSuQmCC",
      style: {"margin-left":"2px","filter":"brightness(45%)"}
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_aside",
    class: _normalizeClass(["aside aside-hoverable", [
      _ctx.asideTheme === 'light' && 'aside-light',
      _ctx.asideTheme === 'dark' && 'aside-dark',
    ]]),
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "aside",
    "data-kt-drawer-activate": "{default: true, lg: false}",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_KTMenu)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, " v." + _toDisplayString(_ctx.version), 1),
      _hoisted_5
    ])
  ], 2))
}